export const enum Routes {
    Base = "*",
    Both = "both",
    BothGoogle = "both_google",
    DynamicBoth = "dynamic-both",
    Flow = "main-flow",
    GLP1 = "glp1",
    PromoPaywall = "paywall", // abandon cart paywall
    PromoPaywallBodyScan = "paywall-body-scan", // abandon cart paywall with body scan offer
    Friends = "friends",
    ChallengesRedirect = "challenges-redirect",
    Age = "age",
    Calisthenics = "calisthenics",
    Offer = "offer",
    E2ETestFunnel = "e2e-test-funnel",
    Funnel = "funnel",
    Seniors = "seniors",
    SeniorsApplovin = "al-seniors",
    Auth = "auth",
    SimplifiedAuth = "simplified-auth",
    ShareVideo = "share-video",
    BothWorkout = "1workout",
    Mex = "mex",
    FreeTrial = "free-trial",
    // routes with age group selection
    AgeLift = "age-lift",
    AgeWeightLoss = "age-weightloss",
    WeightLoss = "weight-loss",
    Promo = "promo",
    AgeWorkout = "age-workout",
    AgeWorkoutLoader = "age-workout-loader",
    CreoTests = "creo-tests",
    AgeWorkoutWithoutAI = "just-age-workout",
    HighIntent = "high-intent",
    CalisthenicsAge = "calisthenics-age",
    Gender = "gender",
    Pilates = "pilates-first",
    BodyScan = "body-scan",
    BodyScanAbs = "body-scan-abs",
    BodyScanPlans = "body-scan-plans",
    BodyScanPlansApplovin = "al-body-scan-plans",
    FFPaywall = "ff-paywall",
    RedeemCode = "redeem-code",
    RedeemPSGCode = "psg-team-offer",
    DirectRedeemCode = "direct-redeem-code",
    Nysc = "nysc",
}

export const enum RedeemCodeRoutes {
    Email = "email",
    Paywall = "paywall",
    Auth = "auth",
    Deeplink = "deeplink",
    AlreadyWithUs = "already-with-us",
    Error = "error",
}
